module.exports = __webpack_public_path__ + "img/special_02.dbb9a15d.png";